<template>
  <v-row justify="center">
    <v-dialog v-model="addModal" persistent max-width="600">
      <v-card justify="center" class="p-3">
        <v-card-title>
          Add Category
          <v-spacer />
          <v-btn icon @click="$emit('closeAddModal')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <v-form @submit.prevent="save" ref="form" lazy-validation>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="name"
                  class="ml-4"
                  name="category"
                  label="Category"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Category Name is required']"
                />
              </v-col>
              <v-col cols="4">
                <v-btn color="secondary" @click="save"> Save </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      name: '',
    };
  },
  props: {
    addModal: {
      type: Boolean,
    },
  },
  methods: {
    save() {
      if (!this.isValid()) {
        return;
      }
      this.$emit('saveCategory', this.name);
    },
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
  },
});
</script>
